module.exports = __webpack_public_path__ + "img/Image_02.89baf76d.jpg";